const data = [
  {
    id: 2,
    category: "Certificate II",
    title: "Certificate II in Community Pharmacy ",
    img: require("./assets/courses/cer2-pharmacy.avif"),
    info: "Contribute to your local community by pursuing a profession in community pharmacy, offering valuable guidance to customers regarding delicate matters like infection prevention, skincare solutions, and sensitive topics. Acquire practical expertise that can be utilized across various sectors of the retail industry, including beauty products and services, inventory management, and pharmacy product recommendations.",
    outcomes: [
      "Engage with clients at the pharmacy counter.",
      "Operate efficiently within a community pharmacy setting.",
      " Implement infection control measures based on pharmacy protocols.",
      "Contribute to workplace health and safety initiatives.",
    ],
  },

  {
    id: 1,
    category: "Certificate III",
    title: "Certificate III in Hospital or Health Services Pharmacy Support",
    img: require("./assets/courses/cer3-hospital.avif"),
    info: "This course  provides individuals with the essential knowledge and skills required to support pharmacy operations in hospital or health service settings. This course offers comprehensive training in various aspects of pharmacy support, enabling students to effectively contribute to the delivery of quality healthcare services.",
    outcomes: [
      "Acquire knowledge and skills in hospital pharmacy practices and procedures.",
      "Demonstrate effective communication and interpersonal skills with patients and professionals.",
      "Contribute to smooth pharmacy operations by maintaining accurate inventory records.",
      "Utilize technology for administrative tasks and medication labeling and packaging.",
    ],
  },

  {
    id: 3,
    category: "Certificate III",
    title: "Certificate III in Community Pharmacy",
    img: require("./assets/courses/cer3-pharmacy.avif"),
    info: "Help a wide range of customers access appropriate medical and cosmetic products as a pharmacy assistant. Through this role, you will develop empathy and multitasking skills while providing assistance to improve people's well-being. Upon completion, you will be prepared for advanced studies in pharmacy dispensary or retail business, expanding your career opportunities.",
    outcomes: [
      "Engage in discussions with customers regarding over-the-counter medications and products.",
      "Familiarize yourself with pharmaceutical terminology and comprehend medication labels.",
      " Handle prescription processing efficiently.",
      "Ensure product shelves are adequately restocked and participate in the arrangement of store displays.",
    ],
  },
  {
    id: 4,
    category: "Certificate IV",
    title: "Certificate IV in Community Pharmacy Dispensary",
    img: require("./assets/courses/cer4-dispensary.avif"),
    info: "Contribute to the health and well-being of your community by acquiring dispensary skills in a community pharmacy, guided by the expertise of a pharmacist. This experience will enhance your customer service abilities, deepen your understanding of retail operations, and provide you with a comprehensive knowledge of pharmaceutical products.",
    outcomes: [
      "Offer support to customers in handling their prescriptions.",
      "Prepare and dispense medications as per prescription requirements.",
      "Provide and promote additional services to customers, enhancing their experience.",
      "Ensure the maintenance of adequate stock levels in the pharmacy.",
    ],
  },
];

export default data;
